var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207 5105 c-169 -46 -317 -183 -379 -350 l-23 -60 -3 -2105 c-2 -1564 0 -2119 8 -2160 37 -175 179 -336 355 -402 l60 -23 1325 -3 c971 -2 1340 0 1380 8 193 41 355 194 417 395 17 57 18 150 18 2155 0 2005 -1 2098 -18 2155 -60 194 -208 340 -397 390 -78 21 -2668 21 -2743 0z m2733 -246 c71 -34 126 -89 161 -164 l29 -60 0 -1662 0 -1663 -1550 0 -1550 0 0 1655 0 1654 22 58 c29 79 104 156 183 188 l60 25 1295 -3 1295 -2 55 -26z m190 -4081 l0 -293 -29 -60 c-35 -75 -90 -130 -161 -164 l-55 -26 -1292 -3 -1292 -2 -58 21 c-79 30 -162 112 -192 192 -20 54 -21 76 -21 342 l0 285 1550 0 1550 0 0 -292z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/Device.5c2c83b610036bbb2c2f2f546935bf79.svg";
export { ForwardRef as ReactComponent };